import { AdminGuard } from '../guards/admin.guard';
import { AuthGuard } from '../guards/auth/auth.guard';

import { DashboardIndexPage } from '../modules/dashboard/pages/index/index.component';

import { LoginComponent } from '../pages/login/login.component';
import { SsoComponent } from '../pages/sso/sso.component';
import { ROUTES_DASBOARD } from './dashboard.routes';
import {VersionInfoComponent} from "@app/pages/version/version-info.component";

export const APP_ROUTES: import('@angular/router').Routes = [
  { path: 'version', component: VersionInfoComponent, children: [] },
  { path: 'login', component: LoginComponent, children: [] },
  { path: 'logout', component: LoginComponent, children: [] },
  { path: 'sso/:token', component: SsoComponent, children: [] },
  {
    path: 'backoffice',
    loadChildren: () => import('../modules/clientesBackOffice/clientesBackOffice.module')
      .then(module => module.ClientesBackOfficeModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'dashboard',
    component: DashboardIndexPage,
    canActivate: [AuthGuard],
    children: ROUTES_DASBOARD,
  },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];
